import React from "react";
import styled from "styled-components";

import { ImCheckboxUnchecked, ImCheckboxChecked } from "react-icons/im";

interface Props {
    isChecked?: boolean;
    onClickHandler?: any;
    className?: string;
}

const CustomCheckbox: React.FC<Props> = ({
    isChecked,
    onClickHandler,
    className,
}) => {
    return (
        <Container
            className={className}
            onClick={(e) => {
                e.stopPropagation();
                if (onClickHandler) onClickHandler();
            }}
        >
            {isChecked ? <ImCheckboxChecked /> : <ImCheckboxUnchecked />}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 0.75rem;
    height: 0.75rem;

    &:hover {
        cursor: pointer;
    }
`;

export default CustomCheckbox;
